import { ConfigurationCreationApi } from "src/api/generated/erp/configurator/api/configurationCreationApi.ts";
import { UnsavedShopOrderPartConfiguratorType } from
	"src/api/generated/erp/configurator/configuratorType/impl/unsavedShopOrderPartConfiguratorType.ts";
import { FormResult } from "src/components/common/forms/types.ts";
import { PartConfiguratorTopLevelView } from
	"src/components/views/erp/configurator/configuratorForm/PartConfiguratorTopLevelView.tsx";
import { DataDirtyStateChangeHandler } from "src/utils/dataDirtyStateChangeHandler.ts";

export interface ShopOrderBeforeCreateConfiguratorViewProps {
	configuratorType: UnsavedShopOrderPartConfiguratorType;
	onCompleted: (result: FormResult<number>) => void;
	onDataDirtyStateChanged?: DataDirtyStateChangeHandler;
}

export function ShopOrderBeforeCreateConfiguratorView({
	configuratorType,
	onCompleted,
	onDataDirtyStateChanged,
}: ShopOrderBeforeCreateConfiguratorViewProps) {
	return (
		<PartConfiguratorTopLevelView
			configuratorType={configuratorType}
			onDataDirtyStateChanged={onDataDirtyStateChanged}
			onCompleted={async (result) => {
				if (result.type === "success") {
					const { propertyValues, propertyInputValues, configurationSessionId } = result.value;
					const partConfigurationId =
						await ConfigurationCreationApi.createPartConfigurationForUnsavedShopOrder({
							configuratorType,
							propertyValues,
							propertyInputValues,
							configurationSessionId,
						});
					onCompleted({ type: "success", value: partConfigurationId });
				} else {
					onCompleted(result);
				}
			}}
		/>
	);
}
